import gql from "graphql-tag";

export const MUNICIPALITY_SELECTIONS = gql`
  query municipalitySelections {
    currentUnit {
      id
      municipalitySelections {
        id
        municipality {
          id
          number
          name
          bban
          organizationNumber
          organizationName
          organizationForm
          comment
          webpage
          email
          telephone
          mobile
          telefax
          address1
          address2
          address3
          zip
          city
          countyName
          employerTaxZone {
            id
            rate
            code
          }
        }
      }
    }
  },
`;
